export const blogTypes = {
  CLOSE_UP: 'close-up',
  PRESS_ROOM: 'press-room',
  FESTIVAL: 'festival',
}

export const getArticleShareUrl = (slug, blogType) =>
  `https://flixpremiere.com/${blogType}/article/${slug}`

export const getCloseUpArticleShareUrl = (slug) => getArticleShareUrl(slug, blogTypes.CLOSE_UP)
export const getPressRoomArticleShareUrl = (slug) => getArticleShareUrl(slug, blogTypes.PRESS_ROOM)
export const getFestivalArticleShareUrl = (slug) => getArticleShareUrl(slug, blogTypes.FESTIVAL)
